export default __webpack_public_path__ + "static/kinesis-e91c1424b330598683b7f99c3f5f855f.webp";